import { EmptyText, EmptyTextContainer, EmptyTextSubtitle } from "@/components/styling/empty";
import EmptyNotesImage from "@/assets/images/empty-notes.svg?react";
import styled from "@emotion/styled";
import { MDSTextColor } from "@/mds";

interface Props {
  isActive: boolean;
}

export const ImportDropTarget = ({ isActive }: Props) => (
  <Wrapper $isActive={isActive} data-test-id="import-dropzone-ui">
    <EmptyNotesImage />
    <EmptyTextContainer>
      <EmptyText color={isActive ? MDSTextColor.Emphasis : MDSTextColor.Secondary}>
        Drag and drop notes into Mem
      </EmptyText>
      <EmptyTextSubtitle color={isActive ? MDSTextColor.Emphasis : MDSTextColor.Tertiary}>
        Supported file types: Text (.txt), Markdown (.md)
      </EmptyTextSubtitle>
    </EmptyTextContainer>
  </Wrapper>
);

const Wrapper = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[5]};
  padding: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.background.card.emphasis : theme.colors.surface.pane};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px dashed
    ${({ theme, $isActive }) =>
      $isActive ? theme.colors.border.emphasis : theme.colors.border.chrome};

  svg {
    max-width: 90%;
    height: auto;
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.icon.emphasis : theme.colors.background.illustration.default};
  }
`;
